<div
  *ngIf="tooltip"
  class="tooltip">
  <div class="tooltip__header-wrapper">
    <div
      class="tooltip__header"
      data-cy="spy-line-chart-tooltip.title">
      <div
        class="tooltip__date"
        data-cy="unique-visits-chart-tooltip.date">
        <span>{{tooltip.date}}</span>
      </div>

      <div *ngIf="tooltip.last && (isDaily$ | async) && (paymentsEnabled$ | async)" class="real-time">
        <div class="real-time__circle">
          <div class="pulse"></div>
        </div>
        <span class="real-time__label">{{'The latest data is shown with a 3-hour delay' | translate}}</span>
      </div>

      <div
        class="tooltip__title"
        data-cy="unique-visits-chart-tooltip.title">
        {{ tooltip.title }}
      </div>
    </div>
  </div>

  <div class="tooltip__values">
    <div class="tooltip__values-wrapper tooltip__values-visits">
      <span class="tooltip__values-label">{{ tooltip.primaryLabel | translate}}</span>
      <span
        [ngStyle]="{'color': tooltip.color}"
        class="tooltip__values-value"
        data-cy="unique-visits-chart-tooltip.visits-value">
        {{ tooltip.primaryValue }}
      </span>
    </div>

    <div
      *ngIf="tooltip.secondaryValue !== undefined && tooltip.secondaryValue !== null"
      class="tooltip__values-wrapper tooltip__values-unique-visits">
      <span class="tooltip__values-label">{{ tooltip.secondaryLabel | translate }}</span>
      <span
        [ngStyle]="{'color': tooltip.color}"
        class="tooltip__values-value"
        data-cy="unique-visits-chart-tooltip.unique-visits-value">
        {{ tooltip.secondaryValue }}
      </span>
    </div>
  </div>
</div>
